module.exports = __webpack_public_path__ + "img/youtube.6b711e84.svg";